"use client";

import * as React from "react";

import BE01 from "@stadium/shared/src/components/plasmic/BE01";
import BE03 from "@stadium/shared/src/components/plasmic/BE03";
import BE04 from "@stadium/shared/src/components/plasmic/BE04";
import BE05 from "@stadium/shared/src/components/plasmic/BE05";
import BE06 from "@stadium/shared/src/components/plasmic/BE06";

import {
  BlogEntryVariant,
  BE_01,
  BE_03,
  BE_04,
  BE_05,
  BE_06,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

interface BE06Card {
  image: string;
  imageAlt: string;
  title: string;
  description: string;
  link: string;
}

export interface BlogEntryProps {
  variant?: BlogEntryVariant;
  className?: string;
  cards?: BE06Card[];
}

const BlogEntry: React.FC<Readonly<BlogEntryProps>> = ({ variant = BE_01, className, ...rest }) => {
  switch (variant) {
    case BE_03:
      return <BE03 className={className} />;
    case BE_04:
      return <BE04 className={className} />;
    case BE_05:
      return <BE05 className={className} />;
    case BE_06:
      return <BE06 className={className} cards={rest.cards} />;
    case BE_01:
    default:
      return <BE01 className={className} />;
  }
};

export default BlogEntry;
